(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gp-assembly-guides"] && !Shopify.designMode) return;
  try {
    function initialiseAssemblyGuides(root) {
  if (root.dataset.ready) return;
  const controls = root.querySelector('.gpa-controls');
  const status = root.querySelector('.gpa-result-status');
  const cards = [...root.querySelectorAll('.gpa-frame-card')];
  const frameButtons = [...root.querySelectorAll('[data-frame]')];
  const colourButtons = [...root.querySelectorAll('button[data-colour]')];
  const versionSelect = root.querySelector('#gpa-version');
  const search = root.querySelector('#gpa-search');
  const groups = [...root.querySelectorAll('.gpa-accessory-group')];
  const count = root.querySelector('#gpa-accessory-count');
  let selectedFrame = '', selectedColour = 'green', selectedVersion = 'current';
  const names = {compact:'The Compact',medium:'The Medium',large:'The Large',xl:'The XL'};
  const normalise = value => value.toLowerCase().replace(/[^a-z0-9]/g, '');
  const groupOpenStates = new Map();
  function updateGuides() {
    const earlier = selectedVersion === 'legacy';
    colourButtons.forEach(button => {button.disabled = earlier; button.setAttribute('aria-pressed',String(button.dataset.colour === selectedColour));});
    frameButtons.forEach(button => button.setAttribute('aria-pressed',String(button.dataset.frame === selectedFrame)));
    let visible = 0;
    cards.forEach(card => {
      card.hidden = card.dataset.model !== selectedFrame || card.dataset.version !== selectedVersion || (!earlier && card.dataset.colour !== selectedColour);
      if (!card.hidden) visible++;
    });
    status.textContent = !selectedFrame ? 'Choose your frame above to see its manuals.' : visible ? `${names[selectedFrame]} · ${earlier ? 'earlier box codes' : selectedColour === 'green' ? 'Green' : 'Blue'} — match the box codes below.` : 'No earlier Green versions are listed. Contact support to match your box codes.';
    const query = normalise(search.value);
    let matches = 0;
    groups.forEach(group => {
      group.hidden = !!query && !normalise(group.dataset.search).includes(query);
      if (!group.hidden) matches++;
      if (query) {
        if (!groupOpenStates.has(group)) groupOpenStates.set(group,group.open);
        group.open = !group.hidden;
      } else if (groupOpenStates.has(group)) {group.open = groupOpenStates.get(group);groupOpenStates.delete(group);}
    });
    count.textContent = `${matches} accessory ${matches === 1 ? 'group' : 'groups'}${query ? ' found' : ' available'}`;
    root.querySelector('.gpa-empty').hidden = matches !== 0;
  }
  function writeUrl(push) {
    const url = new URL(window.location.href);
    for (const [key,value] of [['frame',selectedFrame],['colour',selectedFrame ? selectedColour : ''],['version',selectedFrame ? selectedVersion : ''],['q',search.value]]) {
      if (value) url.searchParams.set(key,value); else url.searchParams.delete(key);
    }
    if (url.href !== window.location.href) history[push ? 'pushState' : 'replaceState'](null,'',url);
  }
  function readUrl() {
    const params = new URL(window.location.href).searchParams;
    selectedFrame = Object.hasOwn(names,params.get('frame')) ? params.get('frame') : '';
    selectedColour = params.get('colour') === 'blue' ? 'blue' : 'green';
    selectedVersion = params.get('version') === 'legacy' ? 'legacy' : 'current';
    if (selectedVersion === 'legacy') selectedColour = 'blue';
    versionSelect.value = selectedVersion;
    search.value = params.get('q') || '';
    updateGuides();
  }
  frameButtons.forEach(button => button.addEventListener('click',()=> {selectedFrame=button.dataset.frame;updateGuides();writeUrl(true);}));
  colourButtons.forEach(button => button.addEventListener('click',()=> {selectedColour=button.dataset.colour;updateGuides();writeUrl(true);}));
  versionSelect.addEventListener('change',()=> {selectedVersion=versionSelect.value;if(selectedVersion==='legacy')selectedColour='blue';updateGuides();writeUrl(true);});
  search.addEventListener('input',()=> {updateGuides();writeUrl(false);});
  window.addEventListener('popstate',readUrl);
  readUrl();
  controls.hidden=false;
  root.querySelector('.gpa-search').hidden=false;
  root.dataset.ready='true';
}
function loadAssemblyGuides() {document.querySelectorAll('[data-assembly-guides]').forEach(initialiseAssemblyGuides);}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',loadAssemblyGuides);else loadAssemblyGuides();
document.addEventListener('shopify:section:load',loadAssemblyGuides);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["junior-layout-motion"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('junior-layout-motion')) {
    customElements.define('junior-layout-motion', class extends HTMLElement {
      connectedCallback() {
        this.image = this.querySelector('img');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.visible = false;
        this.sync = () => {
          const src = !this.motion.matches && this.visible && !document.hidden ? this.image.dataset.animation : this.image.dataset.poster;
          if (this.image.getAttribute('src') !== src) this.image.src = src;
        };
        this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.sync(); });
        this.observer.observe(this);
        this.motion.addEventListener('change', this.sync);
        document.addEventListener('visibilitychange', this.sync);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.motion?.removeEventListener('change', this.sync);
        document.removeEventListener('visibilitychange', this.sync);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["junior-module-explore"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('junior-module-explore')) {
    customElements.define('junior-module-explore', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.dialog = this.querySelector('dialog');
        this.trigger = this.querySelector('.jr-explore__trigger');
        this.trigger.addEventListener('click', event => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
          event.preventDefault();
          if (!this.loaded) {
            this.querySelector('.jr-explore__body').append(this.querySelector('template').content.cloneNode(true));
            this.loaded = true;
          }
          this.scrollPosition = window.scrollY;
          this.bodyStyles = ['position', 'top', 'width', 'overflow'].map(key => [key, document.body.style[key]]);
          Object.assign(document.body.style, { position: 'fixed', top: `-${this.scrollPosition}px`, width: '100%', overflow: 'hidden' });
          this.dialog.showModal();
        });
        this.querySelector('.jr-explore__close').addEventListener('click', () => this.closeDialog());
        this.dialog.addEventListener('cancel', event => {
          event.preventDefault();
          this.closeDialog();
        });
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.closeDialog();
        });
        this.dialog.addEventListener('close', () => { if (!this.dialog.open) this.restore(); });
      }
      closeDialog() { this.dialog.close(); this.restore(); }
      restore() {
        if (!this.bodyStyles) return;
        this.querySelectorAll('video').forEach(video => video.pause());
        this.bodyStyles.forEach(([key, value]) => { document.body.style[key] = value; });
        this.bodyStyles = null;
        window.scrollTo({ top: this.scrollPosition, behavior: 'instant' });
        this.trigger.focus({ preventScroll: true });
      }
      disconnectedCallback() { this.restore(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
